import {USER_LOGOUT} from '../../modules/auth/actions/types';

const initialState = {
    changing: false,
};


export default (state = initialState, action = {}) => {
    if (action.type === 'DIALOG_EVENT') {
        return action.payload;
    } else if (action.type === USER_LOGOUT) {
        return initialState;
    }

    return state;
};




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/dialog.js
 **/